export const mount = () => {
	const wrappers = Array.from(document.querySelectorAll('.filter-search'));
	wrappers.forEach((wrapper) => {
		const field = wrapper.querySelector('.search-field');
		const label = wrapper.querySelector('label');
		const button = wrapper.querySelector('button');

		const search = () => {
			const query = field.value.trim().toLowerCase();
			if (query) {
				window.location.href = '/librairie?search=' + encodeURIComponent(query);
			}
		};

		field.addEventListener('focus', () => {
			wrapper.classList.add('active');
		});
		field.addEventListener('blur', () => {
			if (field.value.trim() === "") {
				wrapper.classList.remove('active');
			}
		});
		field.addEventListener('keyup', (e) => {
			if (e.key === "Enter") {
				search();
			}
		});
		button.addEventListener('click', function () {
			search();
		});
		
	});
	
};

mount();